<script>
import {useStore} from "vuex";
import {onBeforeUnmount, onMounted, ref} from "vue";
import {Carousel, Slide} from 'vue3-carousel';
import 'vue3-carousel/dist/carousel.css';
import FreeWorld from "@/assets/js/FreeWorld";
import BottomNavigation from "@/components/assetComponents/BottomNavigation.vue";
import $ from "jquery";
import router from "@/router";

export default {
  name: "HomePage",
  components: {BottomNavigation, Carousel, Slide},
  setup: function () {

    let store = useStore()

    let profile = ref(FreeWorld.PinkMan(store.state.profile, 'de'))
    let slider = ref(FreeWorld.PinkMan(store.state.slider, 'de'))

    let country = ref(FreeWorld.PinkMan(store.state.country, 'de'))
    let cities = ref([])

    let dialog_city = ref({
      action: false,
      type: 'state',
      state_id: profile.value.state_id,
      city_id: profile.value.city_id,
      city_name: profile.value.city,
    })

    if (store.state.filter.HomePage !== null) dialog_city.value = FreeWorld.PinkMan(store.state.filter.HomePage, 'de')

    let input_search = ref('')

    let helpers = ref(store.state.helpers)


    let x = 0;
    function show_helper() {
      let images = [
        require('@/assets/img/helper/helper_1.jpg'),
        require('@/assets/img/helper/helper_2.jpg'),
        require('@/assets/img/helper/helper_3.jpg'),
        require('@/assets/img/helper/helper_4.jpg'),
        require('@/assets/img/helper/helper_5.jpg'),
        require('@/assets/img/helper/helper_6.jpg'),
        require('@/assets/img/helper/helper_7.jpg'),
        require('@/assets/img/helper/helper_8.jpg'),
        require('@/assets/img/helper/helper_9.jpg'),
        require('@/assets/img/helper/helper_10.jpg'),
        require('@/assets/img/helper/helper_11.jpg'),
      ];

      let img_helper = document.getElementById("helpers");

      // Check if the img_helper element exists
      if (!img_helper) {
        console.error("Element with ID 'helpers' not found.");
        return false;
      }

      // Show the image if there are still images left
      if (x < images.length) {
        img_helper.src = images[x];
        img_helper.style.display = 'block'; // Show the image
        x++;
      } else {
        img_helper.style.display = 'none'; // Hide the image when done
        store.commit('set_helpers' , false)
      }
    }

    function chang_filter(type, id, name) {
      switch (type) {
        case 'show':

          if (dialog_city.value.action) {
            $("#dialog").addClass('animate__fadeOut').removeClass('animate__fadeIn')
            setTimeout(() => {
              dialog_city.value.action = false
              dialog_city.value.type = "state"
            }, 600)
          } else {
            $("#dialog").addClass('animate__fadeIn').removeClass('animate__fadeOut')
            dialog_city.value.action = true
          }
          break

        case 'state':

          dialog_city.value.state_id = id
          cities.value = []
          country.value.forEach((item) => {
            if (item.id === id) {
              cities.value = item.city
              return false
            }
          })
          dialog_city.value.type = 'city'
          break

        case 'city':

          dialog_city.value.city_id = id
          dialog_city.value.city_name = name
          chang_filter('show')
          setTimeout(() => {
            store.commit('set_filter_homepage', dialog_city.value)
          }, 1000)
          break

        case 'search':
          if (input_search.value.length === 0) return false
          router.push({name: 'SearchBy', params: {word: input_search.value}})
      }
    }

    let scroll = false
    onMounted(() => {
      scroll = true
      if (helpers.value) show_helper()
    })
    onBeforeUnmount(() => {
      scroll = false
    })


    $(document).ready(() => {
      if (scroll) {
        $("#chile-main").on('scroll', () => {
          const scrollPosition = $("#chile-main").scrollTop();
          // اگر کاربر به پایین اسکرول کرده باشد، کلاس hidden اضافه شود، در غیر این صورت حذف شود

          scrollPosition > 150 ? $("#add_icon").removeClass('animate__fadeInUpBig').addClass('animate__fadeOutDownBig') : $("#add_icon").removeClass('animate__fadeOutDownBig').addClass('animate__fadeInUpBig')

        });
      }
    });

    store.commit('set_advertising', 'delete')
    store.commit('set_filter_workers', 'delete')
    store.commit('set_add_advertising', 'delete')
    store.commit('set_filter_advertising', 'delete');
    store.commit('set_name_new_service', 'delete');

    return {
      profile,
      slider,
      chang_filter,
      dialog_city,
      country,
      cities,
      input_search,
      show_helper,
    }
  }
}
</script>

<template>

  <div v-show="dialog_city.action" @click="chang_filter('show')" class="bg_dialog"></div>
  <div v-show="dialog_city.action" id="dialog" class="animate__animated animate__fadeIn dialog px-3">
    <div class="rounded-4 bg-white p-3">
      <div class="position-relative">
        <p class="font-4 text-color font-bold text-center">انتخاب استان</p>
        <img @click="chang_filter('show')" class="icon-size-3 position-absolute top-0 start-0"
             src="../assets/img/icon-closeBgColor.svg" alt="">
      </div>

      <hr>

      <p v-if="country.length === 0" class="text-red font-4 text-center">آیتمی برای نمایش وجود ندارد</p>

      <div v-else-if="dialog_city.type === 'state'" style="max-height: 30rem" class="w-100 overflow-y-scroll">
        <div v-for="item in country" :key="item.id" class="">
          <p @click="chang_filter('state' , item.id)" class="p-2 font-5 text-center">{{ item.name }}</p>
          <hr>
        </div>
      </div>

      <div v-else-if="dialog_city.type === 'city'" style="max-height: 30rem"
           class="w-100 animate__animated animate__fadeIn overflow-y-scroll">
        <div v-for="item in cities" :key="item.id" class="">
          <p @click="chang_filter('city' , item.id , item.name)" class="p-2 font-5 text-center">{{ item.name }}</p>
          <hr>
        </div>
      </div>

    </div>
  </div>

  <img style="z-index: 30;display: none" id="helpers" @click="show_helper" src="" class="position-fixed w-100 h-100 max_width" alt="">


  <div id="main" class="bg-color-liner">
    <router-link style="height: 6rem" :to="{name:'ProfilePage'}"
                 class="text-decoration-none d-flex align-items-center p-4">
      <img class="img-profile rounded-pill ms-3 icon_shadow" src="../assets/img/defult-profile.svg" alt="">
      <p class="text-white font-bold font-4">{{ profile.name }}</p>
    </router-link>

    <div style="height: calc(100% - 6rem)" id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <div class="d-flex align-items-center justify-content-around bg-white rounded-pill shadow-custom p-3 mb-4">
        <div class="d-flex align-items-center">
          <img @click="chang_filter('search')" class="icon-size-3" src="../assets/img/icon-search.svg" alt="">
          <input v-model="input_search" @keydown.enter="chang_filter('search')"
                 class="border-0 bg-white text-center font-5" type="text" placeholder="جستجوی عنوان آگهی">
        </div>

        <div class="hr-vertical bg-color"></div>

        <div @click="chang_filter('show')" class="d-flex align-items-center">
          <img class="icon-size-2 ms-2" src="../assets/img/icon-place.svg" alt="">
          <p class="font-5">{{ dialog_city.city_name }}</p>
        </div>
      </div>

      <div class="d-flex justify-content-between mb-5">
        <router-link :to="{name:'CategoryWorker' , params:{type:'service'}}"
                     class="item-list text-decoration-none text-black d-flex w-30 flex-column align-items-center p-3 shadow-KhA rounded-4">
          <img style="width: 6rem" class="mb-3" src="../assets/img/icon-team.svg" alt="">
          <p class="font-6">سرویس کاران</p>
        </router-link>

        <router-link :to="{name:'CategoryWorker' , params:{type:'repair-service'}}"
                     class="item-list text-decoration-none text-black d-flex w-30 flex-column align-items-center p-3 shadow-KhA rounded-4">
          <img style="width: 6rem" class="mb-2" src="../assets/img/icon-worker.svg" alt="">
          <p class="font-6 text-center">تعمیر کاران سرویس کاران</p>
        </router-link>

        <router-link :to="{name:'CategoryWorker' , params:{type:'repairman'}}"
                     class="item-list text-decoration-none text-black d-flex w-30 flex-column align-items-center p-3 shadow-KhA rounded-4">
          <img style="width: 6rem" class="mb-3" src="../assets/img/icon-engineering.svg" alt="">
          <p class="font-6">تعمیر کاران</p>
        </router-link>
      </div>

      <div class="slider rounded-4 mb-5">
        <carousel class="w-100 h-100" :items-to-show="1" :wrapAround="true" :transition="2000" :autoplay="3000"
                  :pauseAutoplayOnHover="true">
          <slide v-for="item in slider" :key="item.index" class="w-100 h-100 px-2 rounded-4">
            <img :src="item" class="slider w-100 rounded-4" alt="">
          </slide>
        </carousel>
      </div>

      <div class="">
        <router-link :to="{name:'MyCars'}" class="text-decoration-none text-color d-flex justify-content-evenly mb-3">
          <div class="p-2 rounded-4 shadow-KhA">
            <img class="icon-size-6" src="../assets/img/icon-myCar.svg" alt="">
          </div>

          <div class="p-2 w-60 rounded-4 shadow-KhA d-flex justify-content-center align-items-center">
            <p class="font-4">خودرو های من</p>
          </div>
        </router-link>

        <router-link :to="{name:'BillOfLadingPage'}" class="d-flex text-decoration-none justify-content-evenly mb-3">
          <div class="p-2 rounded-4 shadow-KhA">
            <img class="icon-size-6" src="../assets/img/icon-barname-home.svg" alt="">
          </div>

          <div class="p-2 w-60 rounded-4 shadow-KhA d-flex justify-content-center align-items-center">
            <p class="font-4 text-color">بارنامه</p>
          </div>
        </router-link>

        <router-link :to="{name:'CarService' , params:{action:'car_expenses'}}"
                     class="d-flex text-decoration-none justify-content-evenly mb-3">
          <div class="p-2 rounded-4 shadow-KhA">
            <img class="icon-size-6" src="../assets/img/icon-car-home.svg" alt="">
          </div>

          <div class="p-2 w-60 rounded-4 shadow-KhA d-flex justify-content-center align-items-center">
            <p class="font-4 text-color">مخارج خودرو</p>
          </div>
        </router-link>

        <router-link :to="{name:'EmergencyNumbers'}" class="d-flex text-decoration-none justify-content-evenly mb-3">
          <div class="p-2 rounded-4 shadow-KhA">
            <img class="icon-size-6" src="../assets/img/icon-phone-emergency.svg" alt="">
          </div>

          <div class="p-2 w-60 rounded-4 shadow-KhA d-flex justify-content-center align-items-center">
            <p class="font-4 text-color">شماره های اضطراری</p>
          </div>
        </router-link>
      </div>

      <br>

      <router-link :to="{name:'CategoryAddAdvertising'}" id="add_icon"
                   class="animate__animated animate__fadeInUpBig position-fixed text-decoration-none max_width bottom-10">
        <img class="icon-size-7 icon_shadow mb-2" src="../assets/img/icon-add.svg" alt="">
        <p class="font-5 bg-color-blue-light rounded-pill p-2 text-decoration-none text-color text-center font-bold">ثبت
          آگهی</p>
      </router-link>

      <BottomNavigation></BottomNavigation>
    </div>
  </div>

</template>

<style scoped>
.img-profile {
  width: 3rem;
  height: 3rem;
}

.slider {
  height: 15rem;
}

.shadow-KhA {
  box-shadow: 0px 8px 18px rgba(189, 215, 234, 0.6);
}
</style>